($ => {  
  const globals = {}
  function initGlobals() {
    CPB.FrontendApi().then(API => globals.api = new API())
    globals.builder = $('#product-builder')
  }

  function isProductComplete() {
    const product = CPB.getStore().getState().Product;
    let requiredNotSelectedCategories = []
    product.panels.forEach(panel => {
      if(globals.api.checkLogic(panel) === false) return
      requiredNotSelectedCategories = requiredNotSelectedCategories.concat(panel.categories.filter(category => {
        if(category.required && !product.layers.find(layer => layer.category === category.id) && globals.api.checkLogic(category)) requiredNotSelectedCategories.push(category)
      }))
    })
    return !requiredNotSelectedCategories.length
  }

  function messagePrescriptions(prescriptionObjects, formContainer, prescriptionId) {
    let resolve
    const promise = new Promise(res => {resolve = res})
    const product = CPB.getStore().getState().Product
    const textarea = formContainer.find('textarea')
    const submitButton = formContainer.find('button.submit')
    let text = 'Product: ' + product.name + '\n'
    text += 'Prescriotion ID: ' + prescriptionId
    prescriptionObjects.forEach((prescriptionObject, i) => {
      const layer = product.layers.find(layer => layer.panel === prescriptionObject.panel.id && layer.category === prescriptionObject.category.id)
      if(layer === undefined) return
      text += '\n' + prescriptionObject.category.title + ': ' + layer.value
    })
    textarea.val(text)
    new MutationObserver(() => {
      if($('.message.success[style*="block"]')) resolve()
    }).observe(formContainer[0], {attributes: true, subtree: true})
    submitButton.trigger('click')
    return promise
  }
  function removePrescriptionsFromProduct(prescriptionObjects, prescriptionId) {
    const product = CPB.getStore().getState().Product
    let hidePrescriptionCategory
    const hidePrescriptionPanel = product.panels.find(panel => {
      hidePrescriptionCategory = panel.categories.find(category => category.extraClassName.includes('hide-prescription--js'))
      return hidePrescriptionCategory
    })
    const promises = []
    prescriptionObjects.forEach(prescriptionObject => {
      const layer = product.layers.find(layer => layer.panel === prescriptionObject.panel.id && layer.category === prescriptionObject.category.id)
      if(layer === undefined) return
      if(prescriptionObject.category.type === 'fileUpload' && hidePrescriptionCategory) {
        hidePrescriptionCategory.options[0].option.data.value = prescriptionId
        hidePrescriptionCategory.options[0].option.data.label = prescriptionId
        const promise = globals.api.updateOptions({
          panel: hidePrescriptionPanel,
          category: hidePrescriptionCategory,
          options: [hidePrescriptionCategory.options[0]]
        })
        promises.push(promise)
      } else {
        prescriptionObject.category.options[0].option.data.value = 'Submitted'
        const promise = globals.api.updateOptions({
          ...prescriptionObject,
          options: prescriptionObject.category.options
        })
        promises.push(promise)
      }      
    })
    return Promise.all(promises)
  }

  function prescriptions() {
    const product = CPB.getStore().getState().Product
    const formContainer = $('#globo-form')
    const prescriptionObjects = []
    product.panels.forEach(panel => {
      const category = panel.categories.find(category => category.extraClassName.includes('prescription--js'))
      if(category) prescriptionObjects.push({panel, category})
    })
    if(prescriptionObjects.length === 0) return
    if(formContainer.length === 0) return
    const addToCart = $('.cpb-add-to-cart-button')
    const customAddToCart = addToCart.clone().attr('class', 'cpb-action-button cpb-custom-add-to-cart-button')
    .on('click', async e => {
      if(isProductComplete() === false) return addToCart.trigger('click')
      const prescriptionId = generatePrescriptionId()
      await messagePrescriptions(prescriptionObjects, formContainer, prescriptionId)
      await removePrescriptionsFromProduct(prescriptionObjects, prescriptionId)
      addToCart.trigger('click')
    })
    addToCart.after(customAddToCart).hide()

    function generatePrescriptionId() {
      return Date.now() + (Math.random() + 1).toString(36).substring(7)
    }
  }
  
  document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', () => {
    initGlobals()
    prescriptions()
  })
})(jQuery)

;document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  console.log("%cCPB is loaded", "color: #1e82dd; font-size: 18px");
});

document.addEventListener('click',function(e){
  if(e.target && e.target.classList.contains('personalize-it--js')){
    window.dispatchEvent(new Event('resize'));
  }
});

